module.exports = __webpack_public_path__ + "static/media/quality_management.b6b6d23c.svg";